import { z } from 'zod';
// Análisis psicométrico con IA (spec 2026-10-16). Permiso por persona, no
// por rol: otros usuarios con rol head no entran a Aspirantes.
export const CORREOS_PSICO = ['veronica@leadsphere.com', 'yael@leadsphere.com'];
// Orden fijo de la batería; también es el orden de las secciones del Word.
export const TIPOS_EXAMEN_PSICO = ['cleaver', 'lifo', 'kostick', 'terman'];
export const MAX_INTENTOS_ANALISIS = 3;
export const MAX_COMENTARIO_ANALISIS = 1000;
export const generarAnalisisBodySchema = z.object({
    tests: z
        .array(z.enum(TIPOS_EXAMEN_PSICO))
        .min(1, 'Marca al menos un test')
        .transform((ts) => TIPOS_EXAMEN_PSICO.filter((t) => ts.includes(t))),
    comentario: z
        .string()
        .trim()
        .max(MAX_COMENTARIO_ANALISIS, `El comentario admite hasta ${MAX_COMENTARIO_ANALISIS} caracteres`)
        .optional()
        .transform((c) => (c ? c : undefined)),
});
//# sourceMappingURL=analisis-psicometrico.js.map